
import { defineComponent } from "vue";
import { mapActions } from "vuex";
import { Optional } from "@/globalTypes";
import Loading from "@/components/Loading.vue";
import LoginButtons from "@/accounts/LoginButtons.vue";
import { sendGTMEvent } from "@/utils";

interface LoginViewData {
  email: string;
  password: string;
  emailError: Optional<String>;
  isSending: boolean;
  isRegistered: boolean;
}

export default defineComponent({
  data(): LoginViewData {
    return {
      email: "",
      password: "",
      emailError: null,
      isSending: false,
      isRegistered: false,
    };
  },
  methods: {
    ...mapActions("accounts", ["register"]),
    handleRegister() {
      this.isSending = true;
      this.register(this.email).then(({ success, result, errors }) => {
        if (success) {
          sendGTMEvent({ event: "rejestracja-niepotwierdzona" }, () => {
            this.isSending = false;
            this.isRegistered = true;
          });
        } else {
          this.emailError = errors;
          this.isSending = false;
        }
      });
    },
  },
  components: { LoginButtons, Loading },
  hideCarHeader: true,
});
